// kyc update
import { Dimensions } from "react-native";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  maxSize,
} from "rn-responsive-styles";
import { COLORS, FONTS } from "../../constant";

const isSmallDevice = Dimensions.get("window").width < 767;
const isTabView =
  Dimensions.get("window").width > 767 && Dimensions.get("window").width < 1024;

const useStyles = CreateResponsiveStyle(
  {
    cardStyle:{
      justifyContent: 'center',
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop : 10,
      marginRight: 10,
      marginBottom: 5,
      width: 305,
      minHeight: 120,
      borderWidth: 1,
      borderColor: COLORS.boderColor,
      borderRadius: 10,
    },
    closureTabStyle : { borderColor: COLORS.orange350, borderWidth: 1, padding: 6, height: 30, borderRadius: 10},
    container: {
      backgroundColor: "#fff",
      borderRadius: 11,
      width: "104%",
      minHeight: 333,
      marginTop: -50,
      marginLeft: -20,
    },
    closurePolicyWidget: {
      flexDirection: "row",
      justifyContent: "space-around",
      backgroundColor: COLORS.lightOrange,
      borderTopLeftRadius: 11,
      borderTopRightRadius: 11,
      alignItems: "center",
      paddingHorizontal: 30,
      maxHeight: 50,
    },
    otpInputViewStyle: {
      width: "100%",
      width: 260,
    },
    closurePolicyText: {
      fontFamily: FONTS.Inter,
      fontSize: 16,
      color: COLORS.white,
      maxWidth: "100%",
    },
    cancelBtn: {
      padding: 6,
      marginRight: 12,
    },
    closeText: {
      color: COLORS.white,
      fontFamily: FONTS.Inter,
      fontSize: 16,
    },
    closureDocWidget: {
      paddingTop: 25,
      flex: 0.5,
    },
    contentWidget: {
      paddingLeft: 70,
      paddingBottom: 40,
    },
    backTextDesc: {
      fontFamily: FONTS.InterMedium,
      fontSize: 12,
      color: COLORS.darkBlack,
      lineHeight: 21,
      letterSpacing: 0.5,
      paddingLeft: 70,
      paddingRight: 30,
      paddingTop: 6,
    },
    digiBtn: {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      paddingHorizontal: 36,
      maxWidth: 180,
    },
    navWidget: {
      flexDirection: "row",
      alignItems: "center",
      width: "100%",
    },
    contentSpace: {
      flex: 0.5,
    },
    closeTagBtn: {
      width: 200,
      alignSelf: "flex-end",
      marginRight: 70,
    },
    scrollViewStyle: {
      marginBottom: -30,
      marginLeft: -10,
    },
    flatListStyle: {
      height: 200,
      paddingBottom: 20,
      marginTop: 20,
    },
   
    viewStyle: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      paddingLeft: 10,
      paddingRight: 10,
      marginRight: 10,
      marginBottom: 5,
      width: 300,
      height: 99,
      borderWidth: 1,
      borderColor: COLORS.boderColor,
      borderRadius: 10,
    },
    searchWidget: {
      flexDirection: "row",
      alignSelf: "flex-end",
      minWidth: 240,
      marginRight: 60,
      marginTop: 15,
      alignItems: "center",
    },
    searchIconContainerStyle: {
      position: "absolute",
      zIndex: 999,
      right: 24,
      top: 10,
    },
    radiobuttonOutSideStyle: {
      width: 15,
      height: 15,
      borderRadius: 10,
      borderColor: "#9d1d27",
      borderWidth: 2,
      alignItems: "center",
      justifyContent: "center",
      marginLeft: 10,
    },
    radioButtonInsideStyle: {
      height: 7,
      width: 7,
      borderRadius: 7,
      backgroundColor: "#9d1d27",
    },
    lowBalanceText: {
      fontSize: 11,
      color: COLORS.red,
      fontWeight: "bold",
      marginLeft: 3,
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 15,
    },
    overlayContainer: {
      width: "90%",
      height: "100%",
      zIndex: 99999,
      alignItems: "center",
      justifyContent: "center",
    },
    overlay: {
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
    },
    overlayContentViewStyle: {
      width: 348,
      height: 270,
      borderRadius: 13,
      backgroundColor: "#ffffff",
      shadowColor: "rgba(0, 0, 0, 0.05)",
      shadowOffset: {
        width: 0,
        height: 27,
      },
      shadowRadius: 34,
      shadowOpacity: 1,
    },
    resendViewStyle: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginHorizontal: "15%",
    },
    flatListStyleNPCI: {
      height: 200,
      paddingBottom: 20,
      marginTop: 20,
      marginLeft:100,
      marginRight:24
    },
    listContentWrapper:{flexDirection:'row',justifyContent:'space-between',width:'100%',},
    listContentR:{width:'40%',marginLeft:10},
    listContentL:{width:504,minHeight:500},
    listContentLBg:{backgroundImage: "linear-gradient(270deg, #54123c 0%, #9d1d27 100%)", width:400, minHeight:300,marginTop:80,padding:22, marginLeft:40, borderRadius:6},
    listContentRTitleBar:{marginTop:40,marginLeft:100},
  },

  {
    [DEVICE_SIZES.LG]: {
      maroonCardStyle: {
        maxWidth: 330,
      },
    },

    [DEVICE_SIZES.MD]: {
      listContentWrapper:{flexDirection:'column',justifyContent:'flex-start'},
      listContentR:{width:'100%',marginLeft:0},
      listContentL:{width:'100%',minHeight:400,maxWidth:'100%',marginLeft:0},
      listContentRTitleBar:{marginTop:50,marginLeft:60},
      flatListStyleNPCI: {
        marginLeft:60,
        marginRight:10
      },
    },

    [maxSize(DEVICE_SIZES.SM)]: {
      dashboard_headerCards_layoutBoxes: {
        width: "100%",
      },
    },

    [DEVICE_SIZES.SM]: {
      container: {
        marginLeft: 0,
        width: "100%",
      },
      mobileText: {
        fontSize: 10,
      },
      closurePolicyWidget: {
        minHeight: 130,
        paddingVertical: 8,
        justifyContent: "space-between",
      },
      contentWidget: {
        paddingLeft: 20,
        paddingBottom: 60,
      },
      overlayViewStyle: {
        left: 0,
        width: "100%",
        paddingLeft: 20,
      },
      closurePolicyText: {
        fontSize: 13,
        maxWidth: 200,
        marginLeft: -10,
      },
      contentSpace: {
        flex: 1,
      },
      navWidget: {
        flexDirection: "column",
        maxWidth: 300,
      },
      backTextDesc: {
        paddingLeft: 20,
        paddingRight: 0,
        fontSize: 10,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        marginLeft: 0,
        width: "100%",
      },
      mobileText: {
        fontSize: 10,
      },
      closurePolicyWidget: {
        minHeight: 130,
        paddingVertical: 8,
        justifyContent: "space-between",
      },
      closurePolicyText: {
        fontSize: 13,
        maxWidth: 180,
        marginLeft: -10,
      },
      navWidget: {
        flexDirection: "column",
        maxWidth: 300,
      },
      contentWidget: {
        paddingLeft: 20,
        paddingBottom: 70,
        marginBottom: 30,
      },
      overlayViewStyle: {
        left: 0,
        width: "100%",
        paddingLeft: 20,
      },
      contentSpace: {
        flex: 1,
      },
      backTextDesc: {
        paddingLeft: 20,
        paddingRight: 0,
        fontSize: 10,
      },
      searchWidget: {
        alignSelf: "flex-start",
      },
      listContentWrapper:{flexDirection:'column',justifyContent:'flex-start'},
      listContentR:{width:'100%',marginLeft:0},
      listContentL:{width:'107%',minHeight:400,maxWidth:'107%',marginLeft:-20},
      listContentLBg:{ width:300, minHeight:300,marginTop:80,padding:22, marginLeft:20, },
      listContentRTitleBar:{marginTop:50,marginLeft:10},
      flatListStyleNPCI: {
        marginLeft:0,
        marginRight:0
      },
      cardStyle:{width : 298 },
      closureTabStyle:{
        padding : 3,
        height:20
      }
    },
  }
);

export default useStyles;
